module.exports = __webpack_public_path__ + "static/media/logo512.be6787e2.png";